export default __webpack_public_path__ + "static/media/泰坦网络.3c31af21.jpg";